export const lang = {
  en: {
    home: "Home",
    profile: "Profile",
    logout: "Logout",
    yes: "Yes",
    deleteAccount: "Delete Account",
    maritalStatus: "Marital Status",
    DeleteAccountFormDescription:
      "Please enter your email address. An email message will be sent to you to verify the process of removing your account.",
    deleteVerifyDescription: "Are you sure you want to delete your account?",
    companyName: "Company Name",
    fullName: "Full Name",
    address: "Address",
    phoneNumber: "Mobile Number",
    email: "Email",
    province: "Province",
    city: "City",
    facebookLink: "Facebook Link",
    linkedinLink: "LinkedIn Link",
    save: "Save",
    signin: "Sign in",
    password: "Password",
    forgotPassword: "Forgot Password",
    dontHaveAccount: "Don't have an account? Sign Up",
    continueAsGuest: "Continue as Guest",
    invalidEmail: "Invalid email",
    requiredField: "This field is required",
    invalidPassword:
      "invalid password, password must be at least 8 characters long",
    forgotPasswordFormDescription:
      "Enter your email so a code will be sent to you.",
    send: "Send",
    passwordNotMatch: "Passwords not matched",
    completeRegistration: "Complete Registration",
    congratulations: "Congratulations",
    recommendedJobs: "Popular Jobs",
    verifyEmailRedirect:
      "Your email has been successfully verified. You can close this page now, and login to your account.",
    error: "Error",
    backToLogin: "Back To Login",
    jobs: "Jobs",
    job_field: "Job Field",
    jobTitle: "Job Title",
    jobTitleTags: "Job Title Tags",
    eduactionDegree: "Eduaction Degree",
    views: "Views",
    appliers: "Appliers",
    operations: "Operations",
    addJob: "Add Job",
    editJob: "Job Details",
    addNewJob: "Add New Job",
    searchJob: "Search Job",
    workType: "Work Type",
    otherJobTitle: "Other Job Title",
    educationDegree: "Education Degree",
    description: "Description",
    fullAddress: "Full Address",
    workDays: "Work Days",
    salary: "Salary",
    dueTo: "Due To",
    gender: "Gender",
    isActive: "Is Active",
    publishEmployerName: "Publish Employer Name",
    sendApplicantEmail: "Email Applicant Details",
    add: "Add",
    delete: "Delete",
    addedSuccess: "Added Successed",
    edit: "Edit",
    applicant: "Applicant",
    showDetailes: "Show Detailes",
    showAll: "Show all",
    editSuccess: "Edit Successed",
    deleteSuccess: "Delete Successed",
    agree: "Agree",
    cancel: "Cancel",
    deleteJobAlertTitle: "Delete Job",
    deleteJobAlertDecription: "Are you sure you want to delete this job?",
    applicants: "Applicants",
    name: "Name",
    applicantStage: "Applicant Stage",
    jobInfo: "Job Information",
    jobPublisherInfo: "Job Publisher Information",
    downloadCv: "Download CV",
    uploadCv: "Upload your CV",
    uploadCvFileTypes: "Allowed file types: pdf, doc, jpg, jpeg, png",
    fileTypeNotAllowed: "File type not allowed",
    updating: "Updating",
    about: "About",
    experience: "Experience",
    skills: "Skills",
    certificates: "Certificates",
    education: "Education",
    present: "Present",
    graduationDate: "Graduation Date",
    startDate: "Start",
    endDate: "End",
    seekerInfo: "Seeker Information",
    showSeekerInfo: "Show Seeker Information",
    nearestPoint: "Nearest Point",
    somethingWentWrong: "Something went wrong, please try again",
    contactEmail: "Contact Email",
    signinWithGoogle: "Sign in with Google",
    searchApplicants: "Search Applicants",
    filter: "Filter",
    clear: "Clear",
    clearAll: "Clear All",
    due: "Due",
    changePassword: "Change Password",
    confirmPassword: "Confirm Password",
    changePasswordSuccess: "Password changed successfully",
    selectYourLocation: "Please Select your location",
    noApplicantsYet: "There are no Applicants yet",
    noJobsYet: "There are no Jobs yet",
    candidates: "Candidates",
    searchCandidates: "Search candidates",
    noCandidatesYet: "No candidates yet",
    salaryFrom: "Minimum Salary",
    salaryTo: "Maximum Salary",
    currency: "Currency",
    notifications: "Notifications",
    noNotification: "There are no notifications yet",
    accepted: "Accepted",
    pendding: "Pendding",
    updateSuccess: "Update Success",
    website: "Website",
    selectResumeTemplate: "Select Resume Template",
    otherJobTitlePlaceholder: "React developer",
    workDaysPlaceholder: "sunday - thursday",
    fullAddressPlaceholder: "14.ramadan street",
    savedJobs: "Saved Jobs",
    jobDescription: "Job Description",
    apply: "Apply",
    contactInfo: "Contact Information",
    remove: "Remove",
    applied: "Applied",
    saveSuccess: "Job saved successfully",
    unsaveSuccess: "Job unsaved sucessfully",
    applySuccess: "Applied to the job sucessfully",
    birthDate: "Birth date",
    drivingLicense: "Driving License",
    languages: "Languages",
    studyField: "Field of Study",
    uniName: " University Name",
    grade: "Grade",
    certificateResource: "Issued by",
    expireDate: "Expire date",
    experiences: "Experiences",
    duties: "Duties",
    newestJobs: "Newest Jobs",
    featuredJobs: "Featured Jobs",
    generateCV: "Create Resume",
    passport: "Passport",
    seeker: "Seeker",
    employer: "Employer",
    unsave: "Unsave",
    jobSaved: "This job is already saved",
    generateCVDesc:
      "Choose the template that you want to use and your resume will be generated automatically based on your information (optional)",
    pageNotFound: "404 - Page Not Found",
    pageNotFoundDescription:
      "The page you are looking for doesn't exist or has been moved",
    backToHome: "Back to Home",
    totalSavedJobs: "Saved Jobs",
    savedJobsDescription: "Track all your bookmarked job opportunities",
    loginToApply: "Login to Apply",
    signInToAccess: "Please sign in to access this page",
    signInRequired: "Sign In Required",
    notSpecified: "Not Specified",
    male: "Male",
    female: "Female",
    both: "Both",
    filters: "Filters",
    showFilters: "Show Filters",
    applyFilters: "Apply Filters",
    clearFilters: "Clear Filters",
    isExpired: "Is Expired",
    totalJobs: "Total Jobs",
    totalViews: "Total Views",
    openedJobs: "Opened Jobs",
    totalApplicants: "Total Applicants",
    createdAt: "Created At",
    confirmStageChange: "Confirm Stage Change",
    areYouSureChangeStage: "Are you sure you want to change the stage to",
    confirm: "Confirm",
    sendRejectionEmail: "Send Rejection Email",
    employerField: "Company Field",
    afterInterview: "After Interview",
    
    // Courses related translations
    courses: "Courses",
    courseName: "Course Name",
    duration: "Duration",
    seats: "Seats",
    price: "Price",
    status: "Status",
    action: "Action",
    noCoursesYet: "There are no Courses yet",
    addNewCourse: "Add New Course",
    totalCourses: "Total Courses",
    activeCourses: "Active Courses",
    totalSeats: "Total Seats",
    uploadImage: "Upload Image",
    editCourse: "Edit Course",
    errorLoadingCourse: "Error loading course data",
    updatedSuccess: "Course updated successfully",
    update: "Update",
    attachment: "Attachment",
    deleteCourseAlertTitle: "Delete Course",
    deleteCourseAlertDecription: "Are you sure you want to delete this course?",
    active: "Active",
    inactive: "Inactive",
    viewDetails: "View Details",
    courseInfo: "Course Information",
    searchCourses: "Search Courses",
    companyInfo: "Company Information",
    downloadAttachment: "Download Attachment",
    seekerCoursesTitle: "Courses",
    shareCourse: "Share Course",
    linkCopied: "Link copied to clipboard!",
    copyFailed: "Failed to copy link",
    noShareLink: "No share link available",
    courseDescription: "Course Description",
    createdBy: "Created by",
    updatedAt: "Updated at",
    actions: "Actions",
    applyNow: "Apply Now",
    contactCompany: "Contact Company",
    courseInactive: "Course Inactive",
    courseFull: "Course Full",
    noApplyLink: "No application link available",
    viewCourseLink: "View Course Link",
    availableSeats: "Available Seats",
    courseCurrentlyInactive: "This course is currently inactive",
    socialMedia: "Social Media",
    aiAssistant: "Noor AI Assistant",
    generateQRCode: "Generate Profile QR Code",
    shareQRCode: "Share QR Code",
    downloadQRCode: "Download QR Code",
    scanToViewProfile: "Scan to view profile",
    shareSuccess: "Shared successfully",
    downloadSuccess: "Downloaded successfully",
    noData: "No data available",
    openToContact: "Open to contact",

    // Support Tickets
    supportTickets: "Support Tickets",
    ticketNumber: "Ticket #",
    ticketTitle: "Title",
    ticketDescription: "Description",
    newTicket: "New Support Ticket",
    createTicket: "Create Ticket",
    noTicketsYet: "No support tickets yet",
    searchTickets: "Search tickets",
    ticketDetails: "Ticket Details",
    comments: "Comments",
    addComment: "Send",
    commentPlaceholder: "Write your comment here...",
    ticketNew: "New",
    ticketInProgress: "In Progress",
    ticketResolved: "Resolved",
    commentsCount: "Comments",
    resolvedAt: "Resolved At",
    ticketCreatedSuccess: "Ticket created successfully",
    commentAddedSuccess: "Comment added successfully",
    ticketResolved_noComments: "This ticket is resolved and no longer accepts new comments.",
    adminReply: "Admin",
    allStatuses: "All Statuses",
    back: "Back",
    maxLength255: "Maximum 255 characters allowed",
    maxLength5000: "Maximum 5000 characters allowed",
  },
  ar: {
    home: "الصفحة الرئيسية",
    generateCV: "انشاء سيرة ذاتية",
    generateCVDesc:
      "اختر النموذج الذي تريد استخدامه وسيتم انشاء السيرة الذاتية بشكل تلقائي بناءً على معلوماتك (اختياري)",
    profile: "معلومات الحساب",
    logout: "تسجيل الخروج",
    yes: "نعم",
    deleteAccount: "حذف الحساب",
    DeleteAccountFormDescription:
      "الرجاء ادخال بريدك الالكتروني. سيتم ارسال رسالة الى بريدك الالكتروني لتاكيد حذف حسابك.",
    deleteVerifyDescription: "هل انت متأكد من حذف حسابك؟",
    companyName: "اسم الشركة",
    fullName: "اسم المستخدم",
    address: "العنوان",
    phoneNumber: "رقم الهاتف",
    email: "البريد الالكتروني",
    province: "المحافظة",
    city: "المدينة",
    facebookLink: "facebook رابط حساب",
    linkedinLink: "linkedin رابط حساب",
    save: "حفظ",
    signin: "تسجيل الدخول",
    password: "كلمة المرور",
    forgotPassword: "هل نسيت كلمة المرور",
    dontHaveAccount: "لا تمتلك حساب؟ انشاء حساب",
    continueAsGuest: "الدخول كمستخدم ضيف",
    invalidEmail: "البريد الالكتروني غير صالح",
    requiredField: "هذاالحقل مطلوب",
    invalidPassword: "كلمة المرور غير صالحة, يجب ان يكون 8 رمز او اكثر",
    forgotPasswordFormDescription:
      "أدخل بريدك الإلكتروني حتى يتم إرسال الرمز إليك.",
    send: "ارسال",
    passwordNotMatch: "كلمة المرور غير متطابقة",
    completeRegistration: "اكمال عملية انشاء الحساب",
    congratulations: "تهانينا",
    verifyEmailRedirect:
      "تم التحقق من بريدك الإلكتروني بنجاح. يمكنك الآن إغلاق هذه الصفحة وتسجيل الدخول إلى حسابك.",
    error: "حدث خطأ ما",
    backToLogin: "العودة إلى صفحة تسجيل الدخول",
    jobs: "الوظائف",
    jobTitle: "عنوان الوظيفة",
    jobTitleTags: "المسميات الوظيفية",
    eduactionDegree: "درجة التعليم",
    views: "المشاهدات",
    appliers: "تم التقديم",
    operations: "العمليات",
    addJob: "اضافة وظيفة",
    editJob: "تفاصيل الوظيفة",
    addNewJob: "اضافة وظيفة جديدة",
    searchJob: "بحث عن وظيفة",
    workType: "نوع العمل",
    otherJobTitle: "عنوان اضافي للوظيفة",
    educationDegree: "التحصيل الدراسي",
    description: "الوصف",
    fullAddress: "العنوان الكامل",
    workDays: "ايام العمل",
    salary: "الراتب",
    dueTo: "صالحة لغاية",
    gender: "الجنس",
    showAll: "عرض الكل",
    isActive: "نشر",
    publishEmployerName: "اضهار اسم الموظف",
    sendApplicantEmail: "ارسال تفاصيل المتقدمين بالبريد الالكتروني",
    add: "اضافة",
    delete: "حذف",
    addedSuccess: "تمت الاضافة بنجاح",
    edit: "تعديل",
    applicant: "المتقدمين",
    showDetailes: "عرض التفاصيل",
    editSuccess: "تم التحديث بنجاح",
    deleteSuccess: "تم الحذف بنجاح",
    agree: "موافق",
    cancel: "الغاء",
    deleteJobAlertTitle: "حذف وظيفة",
    deleteJobAlertDecription: "هل انت متأكد من حذف هذه الوظيفة؟",
    applicants: "المتقدمين",
    name: "الاسم",
    applicantStage: "حالة التقديم",
    jobInfo: "معلومات الوظيفة",
    jobPublisherInfo: "معلومات الناشر",
    downloadCv: "تحميل السيرة الذاتية",
    updating: "تحديث",
    about: "نبذة عامة",
    experience: "الخبرة",
    certificates: "الشهادات",
    education: "التعليم",
    skills: "المهارات",
    present: "مستمر",
    graduationDate: "تاريخ التخرج",
    startDate: "تاريخ اليدء",
    endDate: "تاريخ الانتهاء",
    seekerInfo: "معلومات المتقدم",
    showSeekerInfo: "عرض معلومات المتقدم",
    recommendedJobs: "الوضائف الشائعة",
    newestJobs: "احدث الوظائف",
    featuredJobs: "الوظائف المميزة",
    nearestPoint: "اقرب نقطة دالة",
    somethingWentWrong: "حصل خطأ ما الرجاء المحاولة فيما بعد",
    contactEmail: "البريد الالكتروني المخصص للتواصل",
    signinWithGoogle: "تسجيل الدخول بواسطة البريد الالكتروني",
    searchApplicants: "بحث عن متقدم",
    filter: "تصفية",
    clear: "الغاءالتصفية",
    due: "صالحة لغاية",
    changePassword: "تغير كلمة المرور",
    confirmPassword: "تأكيد كلمة المرور",
    changePasswordSuccess: "تم تغير كلمة المرور بنجاح",
    selectYourLocation: "يرجى تحديد الموقع الخاص بك",
    noApplicantsYet: "لا يوجد متقدمين حتى الان",
    noJobsYet: "لم يتم اضافة وظيفة حتى الان",
    candidates: "المرشحين",
    searchCandidates: "البحث عن مرشحين",
    noCandidatesYet: "لا يوجد مرشحين بعد",
    salaryFrom: "الحد الادنى للمرتب",
    salaryTo: "الحد الاعلى للمرتب",
    currency: "العملة",
    notifications: "ألاشعارات",
    noNotification: "لا توجد اشعارات",
    accepted: "مفعل",
    pendding: "قيد الموافقة",
    clearAll: "مسح الكل",
    updateSuccess: "تم التحديث بنجاح",
    website: "الموقع الالكتروني",
    selectResumeTemplate: "اختيار القالب للسيرة الذاتية",
    otherJobTitlePlaceholder: "مطور React",
    workDaysPlaceholder: "الاحد - الخميس",
    fullAddressPlaceholder: "شارع 14 رمضان",
    savedJobs: "الوظائف المحفوظة",
    jobDescription: "وصف الوظيفة",
    apply: "تقديم",
    contactInfo: "معلومات التواصل",
    remove: "مسح",
    applied: "تم التقديم",
    saveSuccess: "تم حفظ الوظيفة بنجاح",
    unsaveSuccess: "تم حذف الوظيفة بنجاح",
    applySuccess: "تم التقديم على الوظيفة بنجاح",
    birthDate: "تاريخ الميلاد",
    job_field: "المجال الوظيفي",
    maritalStatus: "الحالة الزوجية",
    passport: "جواز سفر",
    jobSaved: "تم حفظ الوظيفة مسبقاً",
    uploadCv: "رفع السيرة الذاتية",
    uploadCvFileTypes: "الملفات المسموح بها: pdf, doc, jpg, jpeg, png",
    fileTypeNotAllowed: "نوع الملف غير مسموح",
    drivingLicense: "اجازة السوق",
    languages: "اللغات",
    studyField: "قسم الدراسة",
    uniName: "اسم الجامعة",
    grade: "الدرجة او المعدل",
    certificateResource: "جهة الاصدار",
    expireDate: "تاريخ الانتهاء",
    experiences: "الخبرات",
    duties: "الواجبات",

    seeker: "باحث عن وظيفة",
    employer: "شركة",
    unsave: "الغاء الحفظ",
    pageNotFound: "404 - صفحة غير موجودة",
    pageNotFoundDescription: "الصفحة التي تبحث عنها غير موجودة أو تم نقلها",
    backToHome: "العودة الى الرئيسية",
    totalSavedJobs: "الوظائف المحفوظة",
    savedJobsDescription: "تتبع جميع فرص العمل المحفوظة لديك",
    loginToApply: "سجل الدخول للتفديم",
    signInToAccess: "يرجى تسجيل الدخول للوصول الى هذه الصفحة",
    signInRequired: "تسجيل الدخول مطلوب",
    notSpecified: "غير محدد",
    male: "ذكر",
    female: "أنثى",
    both: "كلاهما",
    filters: "التصفية",
    showFilters: "عرض التصفية",
    applyFilters: "تطبيق التصفية",
    clearFilters: "مسح التصفية",
    isExpired: "منتهية",
    totalJobs: "عدد الوظائف",
    totalViews: "عدد المشاهدات",
    openedJobs: "عدد الوظائف المفتوحة",
    totalApplicants: "عدد المتقدمين",
    createdAt: "تاريخ الانشاء",
    confirmStageChange: "تأكيد تغيير حالة التقديم",
    areYouSureChangeStage: "هل انت متأكد من تغيير حالة التقديم الى",
    confirm: "تأكيد",
    sendRejectionEmail: "ارسال رسالة رفض",
    employerField: "المجال التجاري",
    afterInterview: "بعد المقابلة",
    
    // Courses related translations
    courses: "الدورات",
    courseName: "اسم الدورة",
    duration: "المدة",
    seats: "المقاعد",
    price: "السعر",
    status: "الحالة",
    action: "الإجراء",
    noCoursesYet: "لا توجد دورات حتى الآن",
    addNewCourse: "إضافة دورة جديدة",
    totalCourses: "إجمالي الدورات",
    activeCourses: "الدورات النشطة",
    totalSeats: "إجمالي المقاعد",
    uploadImage: "رفع صورة",
    editCourse: "تعديل الدورة",
    errorLoadingCourse: "خطأ في تحميل بيانات الدورة",
    updatedSuccess: "تم تحديث الدورة بنجاح",
    update: "تحديث",
    attachment: "المرفق",
    deleteCourseAlertTitle: "حذف الدورة",
    deleteCourseAlertDecription: "هل أنت متأكد من حذف هذه الدورة؟",
    active: "نشط",
    inactive: "غير نشط",
    viewDetails: "عرض التفاصيل",
    courseInfo: "معلومات الدورة",
    searchCourses: "البحث عن دورات",
    companyInfo: "معلومات الشركة",
    downloadAttachment: "تحميل المرفق",
    seekerCoursesTitle: "الدورات",
    shareCourse: "مشاركة الدورة",
    linkCopied: "تم نسخ الرابط إلى الحافظة!",
    copyFailed: "فشل في نسخ الرابط",
    noShareLink: "لا يوجد رابط مشاركة متاح",
    courseDescription: "وصف الدورة",
    createdBy: "أنشئت بواسطة",
    updatedAt: "تاريخ التحديث",
    actions: "الإجراءات",
    applyNow: "التقديم الآن",
    contactCompany: "اتصل بالشركة",
    courseInactive: "الدورة غير نشطة",
    courseFull: "الدورة مكتملة",
    noApplyLink: "لا يوجد رابط تقديم متاح",
    viewCourseLink: "عرض رابط الدورة",
    availableSeats: "المقاعد المتاحة",
    courseCurrentlyInactive: "هذه الدورة غير نشطة حالياً",
    socialMedia: "وسائل التواصل الاجتماعي",
    aiAssistant: "نور المساعد الذكي",
    generateQRCode: "إنشاء رمز QR للملف الشخصي",
    shareQRCode: "مشاركة رمز QR",
    downloadQRCode: "تحميل رمز QR",
    scanToViewProfile: "امسح لعرض الملف الشخصي",
    shareSuccess: "تمت المشاركة بنجاح",
    downloadSuccess: "تم التحميل بنجاح",
    noData: "لا توجد بيانات متاحة",
    openToContact: "متاح للتواصل",

    // Support Tickets
    supportTickets: "تذاكر الدعم",
    ticketNumber: "رقم التذكرة",
    ticketTitle: "العنوان",
    ticketDescription: "الوصف",
    newTicket: "تذكرة دعم جديدة",
    createTicket: "إنشاء تذكرة",
    noTicketsYet: "لا توجد تذاكر دعم بعد",
    searchTickets: "البحث في التذاكر",
    ticketDetails: "تفاصيل التذكرة",
    comments: "التعليقات",
    addComment: "إرسال",
    commentPlaceholder: "اكتب تعليقك هنا...",
    ticketNew: "جديدة",
    ticketInProgress: "قيد المعالجة",
    ticketResolved: "تم الحل",
    commentsCount: "التعليقات",
    resolvedAt: "تاريخ الحل",
    ticketCreatedSuccess: "تم إنشاء التذكرة بنجاح",
    commentAddedSuccess: "تم إضافة التعليق بنجاح",
    ticketResolved_noComments: "هذه التذكرة تم حلها ولم تعد تقبل تعليقات جديدة.",
    adminReply: "المسؤول",
    allStatuses: "جميع الحالات",
    back: "رجوع",
    maxLength255: "الحد الأقصى 255 حرف",
    maxLength5000: "الحد الأقصى 5000 حرف",
  },
};

/**
 * Get language object for code param.
 * @param {string} code code for language, `default is "en"`
 * @returns
 */
export function getLang(code = "en") {
  return lang[code];
}
/**
 * Return translate for word by passing language code and text key fro word.
 * @param {*} code  language code.
 * @param {*} textKey text key for word.
 * @returns
 */
export function getLangTranslate(code, textKey) {
  return lang[code][textKey];
}
